import { ValidateEmailAddr } from "./ValidateEmailAddr";

export function ValidateEmailAddrList(addrList) {
  for (var i = 0; i < addrList.length; i++) {
    var s = addrList[i].split(",");
    var v = s[0];
    var isValid = ValidateEmailAddr(v);
    if (isValid == false) return false;
  }

  return true;
}
